const MAX_NEGATIVE_KEYWORD_PHRASE_LENGTH = 4;
const MAX_NEGATIVE_KEYWORD_EXACT_LENGTH = 10;
const MAX_KW_LENGTH = 80;

export const getValidKeywordToNegate = (matchType: string, keywordText: string) => {
  const wordCount = keywordText.trim().split(/\s+/).filter(Boolean).length;

  if (matchType === "negative_phrase") {
    return keywordText.length <= MAX_KW_LENGTH && wordCount <= MAX_NEGATIVE_KEYWORD_PHRASE_LENGTH;
  }

  if (matchType === "negative_exact") {
    return keywordText.length <= MAX_KW_LENGTH && wordCount <= MAX_NEGATIVE_KEYWORD_EXACT_LENGTH;
  }

  return true;
};
